import "./PriceSlip.css";
function PriceSlip({ content }) {
  return <div className="price-slip">{content}</div>;
}

export default PriceSlip;
